module.exports = __webpack_public_path__ + "img/crossover_parked.926986ce.svg";